import http, {download, uploadCfg} from "../../../utils/HttpUtils";

function parsePageData(pageData) {
    let {list, ...page} = pageData
    return {page, list}
}

//
class MaterialService {
    static async findTypeTree() {
        const apiUrl = "/dict/findMaterialSortTree";
        return await http.get(apiUrl);
    }

    //添加物料
    static async insert(data) {
        const apiUrl = "/base/material/insert";
        return await http.post(apiUrl, data);
    }

    //修改物料
    static async update(data) {
        const apiUrl = "/base/material/update";
        return http.post(apiUrl, data);
    }
    //修改物料状态
    static async enableOrDisable(data) {
        const apiUrl = `/base/material/enableOrDisable/${data.id}/${data.materialStatus}`;
        return http.get(apiUrl);
    }
    //查询一条物料信息
    static async findOne(id) {
        const apiUrl = "/scmMaterial/find/" + id;
        return http.get(apiUrl);
    }

    //分页查询物料信息
    static async findPage(data) {
        const apiUrl = "/base/material/listPage";
        return http.post(apiUrl, data);
    }

    //删除一条物料信息
    static async deleteOne(id) {
        const apiUrl = "/scmMaterial/deleteOne/" + id;
        return http.get(apiUrl);
    }

    //导出数据
    static async export(res) {
        const apiUrl = "/base/material/export";
        await download(apiUrl,res)
    }
    //下载模板
    static async downloadTpl() {
        const apiUrl = "/base/material/downloadTpl";
        await download(apiUrl)
    }

    //获取导入配置
    static getImportCfg(cfg) {
        const apiUrl = "/base/material/import";
        return uploadCfg(apiUrl, cfg);
    }
}

export default MaterialService;
